module.exports = __webpack_public_path__ + "img/imgs-item-5.72facfbe.png";